import { z } from "zod";
import { isPermission, type Permission } from "../permissions.js";
import { SUPPORTED_LOCALES } from "../locales.js";

export const userInviteSchema = z.object({
  firstName: z.string().trim().min(1).max(80),
  lastName: z.string().trim().min(1).max(80),
  email: z.string().trim().toLowerCase().email().max(120),
  roleIds: z.array(z.string().uuid()).min(1),
  locale: z.enum(SUPPORTED_LOCALES).default("en"),
});
export type UserInviteDto = z.infer<typeof userInviteSchema>;

export const userUpdateSchema = z.object({
  firstName: z.string().trim().min(1).max(80).optional(),
  lastName: z.string().trim().min(1).max(80).optional(),
  roleIds: z.array(z.string().uuid()).min(1).optional(),
  locale: z.enum(SUPPORTED_LOCALES).optional(),
  status: z.enum(["invited", "active", "suspended", "deactivated"]).optional(),
});
export type UserUpdateDto = z.infer<typeof userUpdateSchema>;

const permissionSchema = z.string().refine(isPermission, "Unknown permission");

export const roleCreateSchema = z.object({
  name: z.string().trim().min(1).max(80),
  description: z.string().trim().max(500).optional(),
  permissions: z.array(permissionSchema).default([]),
});
export type RoleCreateDto = z.infer<typeof roleCreateSchema>;

export const roleUpdateSchema = roleCreateSchema.partial();
export type RoleUpdateDto = z.infer<typeof roleUpdateSchema>;

export interface RoleResponse {
  id: string;
  name: string;
  description?: string;
  isSystem: boolean;
  isAdmin: boolean;
  permissions: Permission[];
  userCount: number;
  createdAt: string;
  updatedAt: string;
}

export interface UserResponse {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  locale: string;
  status: "invited" | "active" | "suspended" | "deactivated";
  roles: Array<{ id: string; name: string; isAdmin: boolean }>;
  employee?: {
    employeeNumber?: string;
    phone?: string;
    jobTitle?: string;
    pensumPercent: string;
  };
  lastLoginAt?: string;
  createdAt: string;
  updatedAt: string;
}
